import React from "react";

function Repair() {
  return <div>Repair Repair</div>;
}

export default Repair;
